import { getDrawerContentById } from '../getDrawerContentById';
import { PromoCodeCopy } from '../PromoCodeCopy';
export const shortcodeIdToFuncMap = new Map([['drawer', {
  shortcodeAction: null,
  shortcodeAttrsToArgs: attrs => attrs,
  shortcodeAttrsToResult: attrs => getDrawerContentById(attrs)
}], ['promo', {
  shortcodeAction: null,
  shortcodeAttrsToArgs: attrs => attrs,
  shortcodeAttrsToResult: () => PromoCodeCopy()
}]]);
export default shortcodeIdToFuncMap;